<template>
  <div class="financial-statement-item">
    <col-table :data="data" :pageSize="pageSize" :class="{ 'col-table--same': isSame, 'table-var': true }">
      <col-table-column label="日期" prop="endDate" :css="{ height: '50px' }">
        <template #header>
          <div class="date-header">
            <span>报告期<i class="iconfont icon-wenhao ml-4px" @click="popupVisible = true"></i></span>
            <span class="tongbi">
              {{ $t('同比')
              }}<span class="checkbox-wrap"><input type="checkbox" v-model="isSame" class="checkbox" /></span>
            </span>
          </div>
        </template>
        <template slot-scope="scope">
          <div class="value-wrap">
            <span class="value">{{ scope.row.sortYear + scope.row.reportType }}</span>
            <span class="scale">{{ $t('同比') }}</span>
          </div>
        </template>
      </col-table-column>
      <col-table-column prop="reportKind" label="报表种类">
        <template slot-scope="scope">{{
          $digitjs(reportKindMap[scope.row[formatAParams('reportKind')]]).isNull()
        }}</template>
      </col-table-column>
      <col-table-column prop="coverMonths" label="覆盖时期(月)">
        <template slot-scope="scope">{{ $digitjs(scope.row[formatAParams('coverMonths')]).isNull() }}</template>
      </col-table-column>
      <col-table-column prop="currency" label="报表货币" :css="{ marginBottom: '17px' }">
        <template slot-scope="scope">{{ $digitjs(scope.row[formatAParams('currency')]).isNull() }}</template>
      </col-table-column>
      <col-table-column :css="css">
        <template #header>资产</template>
      </col-table-column>
      <col-table-column prop="investmentProperties" label="投资物业">
        <template slot-scope="scope">
          <div class="value-wrap">
            <span class="value">{{ $digitjs(scope.row[formatAParams('investmentProperties')]).convert() }}</span>
            <span
              :style="{ color: $digitjs(scope.row[formatAParams('investmentPropertiesYoY')]).color() }"
              class="scale"
            >
              {{ $digitjs(scope.row[formatAParams('investmentPropertiesYoY')]).prefix().unit('%').rounded() }}
            </span>
          </div>
        </template>
      </col-table-column>
      <col-table-column prop="propertyAndEquipment" label="房屋,产房及设备">
        <template slot-scope="scope">
          <div class="value-wrap">
            <span class="value">{{ $digitjs(scope.row[formatAParams('propertyAndEquipment')]).convert() }}</span>
            <span
              :style="{ color: $digitjs(scope.row[formatAParams('propertyAndEquipmentYoY')]).color() }"
              class="scale"
            >
              {{ $digitjs(scope.row[formatAParams('propertyAndEquipmentYoY')]).prefix().unit('%').rounded() }}
            </span>
          </div>
        </template>
      </col-table-column>
      <col-table-column prop="leaseholdLandAndUseRights" label="租赁土地权益">
        <template slot-scope="scope">
          <div class="value-wrap">
            <span class="value">{{ $digitjs(scope.row[formatAParams('leaseholdLandAndUseRights')]).convert() }}</span>
            <span
              :style="{ color: $digitjs(scope.row[formatAParams('leaseholdLandAndUseRightsYoY')]).color() }"
              class="scale"
            >
              {{ $digitjs(scope.row[formatAParams('leaseholdLandAndUseRightsYoY')]).prefix().unit('%').rounded() }}
            </span>
          </div>
        </template>
      </col-table-column>
      <col-table-column prop="prepaidLandAndLeasePremiums" label="预付土地/租赁款项">
        <template slot-scope="scope">
          <div class="value-wrap">
            <span class="value">{{ $digitjs(scope.row[formatAParams('prepaidLandAndLeasePremiums')]).convert() }}</span>
            <span
              :style="{ color: $digitjs(scope.row[formatAParams('prepaidLandAndLeasePremiumsYoY')]).color() }"
              class="scale"
            >
              {{ $digitjs(scope.row[formatAParams('prepaidLandAndLeasePremiumsYoY')]).prefix().unit('%').rounded() }}
            </span>
          </div>
        </template>
      </col-table-column>
      <col-table-column prop="fixedAssets" label="固定资产">
        <template slot-scope="scope">
          <div class="value-wrap">
            <span class="value">{{ $digitjs(scope.row[formatAParams('fixedAssets')]).convert() }}</span>
            <span :style="{ color: $digitjs(scope.row[formatAParams('fixedAssetsYoY')]).color() }" class="scale">
              {{ $digitjs(scope.row[formatAParams('fixedAssetsYoY')]).prefix().unit('%').rounded() }}
            </span>
          </div>
        </template>
      </col-table-column>
      <col-table-column prop="debtSecurities" label="债权类证券">
        <template slot-scope="scope">
          <div class="value-wrap">
            <span class="value">{{ $digitjs(scope.row[formatAParams('debtSecurities')]).convert() }}</span>
            <span :style="{ color: $digitjs(scope.row[formatAParams('debtSecuritiesYoY')]).color() }" class="scale">
              {{ $digitjs(scope.row[formatAParams('debtSecuritiesYoY')]).prefix().unit('%').rounded() }}
            </span>
          </div>
        </template>
      </col-table-column>
      <col-table-column prop="equitySecurities" label="股权类证券">
        <template slot-scope="scope">
          <div class="value-wrap">
            <span class="value">{{ $digitjs(scope.row[formatAParams('equitySecurities')]).convert() }}</span>
            <span :style="{ color: $digitjs(scope.row[formatAParams('equitySecuritiesYoY')]).color() }" class="scale">
              {{ $digitjs(scope.row[formatAParams('equitySecuritiesYoY')]).prefix().unit('%').rounded() }}
            </span>
          </div>
        </template>
      </col-table-column>
      <col-table-column prop="derivativeFinancialAssets" label="衍生金融资产">
        <template slot-scope="scope">
          <div class="value-wrap">
            <span class="value">{{ $digitjs(scope.row[formatAParams('derivativeFinancialAssets')]).convert() }}</span>
            <span
              :style="{ color: $digitjs(scope.row[formatAParams('derivativeFinancialAssetsYoY')]).color() }"
              class="scale"
            >
              {{ $digitjs(scope.row[formatAParams('derivativeFinancialAssetsYoY')]).prefix().unit('%').rounded() }}
            </span>
          </div>
        </template>
      </col-table-column>
      <col-table-column prop="loans" label="贷款">
        <template slot-scope="scope">
          <div class="value-wrap">
            <span class="value">{{ $digitjs(scope.row[formatAParams('loans')]).convert() }}</span>
            <span :style="{ color: $digitjs(scope.row[formatAParams('loansYoY')]).color() }" class="scale">
              {{ $digitjs(scope.row[formatAParams('loansYoY')]).prefix().unit('%').rounded() }}
            </span>
          </div>
        </template>
      </col-table-column>
      <col-table-column prop="otherInvestments" label="其他投资">
        <template slot-scope="scope">
          <div class="value-wrap">
            <span class="value">{{ $digitjs(scope.row[formatAParams('otherInvestments')]).convert() }}</span>
            <span :style="{ color: $digitjs(scope.row[formatAParams('otherInvestmentsYoY')]).color() }" class="scale">
              {{ $digitjs(scope.row[formatAParams('otherInvestmentsYoY')]).prefix().unit('%').rounded() }}
            </span>
          </div>
        </template>
      </col-table-column>
      <col-table-column prop="interestsInAssociates" label="联营公司权益">
        <template slot-scope="scope">
          <div class="value-wrap">
            <span class="value">{{ $digitjs(scope.row[formatAParams('interestsInAssociates')]).convert() }}</span>
            <span
              :style="{ color: $digitjs(scope.row[formatAParams('interestsInAssociatesYoY')]).color() }"
              class="scale"
            >
              {{ $digitjs(scope.row[formatAParams('interestsInAssociatesYoY')]).prefix().unit('%').rounded() }}
            </span>
          </div>
        </template>
      </col-table-column>
      <col-table-column prop="interestsInJointVentures" label="共同控制公司权益">
        <template slot-scope="scope">
          <div class="value-wrap">
            <span class="value">{{ $digitjs(scope.row[formatAParams('interestsInJointVentures')]).convert() }}</span>
            <span
              :style="{ color: $digitjs(scope.row[formatAParams('interestsInJointVenturesYoY')]).color() }"
              class="scale"
            >
              {{ $digitjs(scope.row[formatAParams('interestsInJointVenturesYoY')]).prefix().unit('%').rounded() }}
            </span>
          </div>
        </template>
      </col-table-column>
      <col-table-column prop="goodwill" label="商誉">
        <template slot-scope="scope">
          <div class="value-wrap">
            <span class="value">{{ $digitjs(scope.row[formatAParams('goodwill')]).convert() }}</span>
            <span :style="{ color: $digitjs(scope.row[formatAParams('goodwillYoY')]).color() }" class="scale">
              {{ $digitjs(scope.row[formatAParams('goodwillYoY')]).prefix().unit('%').rounded() }}
            </span>
          </div>
        </template>
      </col-table-column>
      <col-table-column prop="otherIntangileAssets" label="其他无形资产">
        <template slot-scope="scope">
          <div class="value-wrap">
            <span class="value">{{ $digitjs(scope.row[formatAParams('otherIntangileAssets')]).convert() }}</span>
            <span
              :style="{ color: $digitjs(scope.row[formatAParams('otherIntangileAssetsYoY')]).color() }"
              class="scale"
            >
              {{ $digitjs(scope.row[formatAParams('otherIntangileAssetsYoY')]).prefix().unit('%').rounded() }}
            </span>
          </div>
        </template>
      </col-table-column>
      <col-table-column prop="insuranceReceivables" label="应收保险款项">
        <template slot-scope="scope">
          <div class="value-wrap">
            <span class="value">{{ $digitjs(scope.row[formatAParams('insuranceReceivables')]).convert() }}</span>
            <span
              :style="{ color: $digitjs(scope.row[formatAParams('insuranceReceivablesYoY')]).color() }"
              class="scale"
            >
              {{ $digitjs(scope.row[formatAParams('insuranceReceivablesYoY')]).prefix().unit('%').rounded() }}
            </span>
          </div>
        </template>
      </col-table-column>
      <col-table-column prop="reinsuranceAssets" label="分保资产">
        <template slot-scope="scope">
          <div class="value-wrap">
            <span class="value">{{ $digitjs(scope.row[formatAParams('reinsuranceAssets')]).convert() }}</span>
            <span :style="{ color: $digitjs(scope.row[formatAParams('reinsuranceAssetsYoY')]).color() }" class="scale">
              {{ $digitjs(scope.row[formatAParams('reinsuranceAssetsYoY')]).prefix().unit('%').rounded() }}
            </span>
          </div>
        </template>
      </col-table-column>
      <col-table-column prop="amountDueFromRelatedParties" label="应收关连公司款项">
        <template slot-scope="scope">
          <div class="value-wrap">
            <span class="value">{{ $digitjs(scope.row[formatAParams('amountDueFromRelatedParties')]).convert() }}</span>
            <span
              :style="{ color: $digitjs(scope.row[formatAParams('amountDueFromRelatedPartiesYoY')]).color() }"
              class="scale"
            >
              {{ $digitjs(scope.row[formatAParams('amountDueFromRelatedPartiesYoY')]).prefix().unit('%').rounded() }}
            </span>
          </div>
        </template>
      </col-table-column>
      <col-table-column prop="deferredPolicyAcquisitionCosts" label="递延保单获取成本变动">
        <template slot-scope="scope">
          <div class="value-wrap">
            <span class="value">{{
              $digitjs(scope.row[formatAParams('deferredPolicyAcquisitionCosts')]).convert()
            }}</span>
            <span
              :style="{ color: $digitjs(scope.row[formatAParams('deferredPolicyAcquisitionCostsYoY')]).color() }"
              class="scale"
            >
              {{ $digitjs(scope.row[formatAParams('deferredPolicyAcquisitionCostsYoY')]).prefix().unit('%').rounded() }}
            </span>
          </div>
        </template>
      </col-table-column>
      <col-table-column prop="deferredTaxAssets" label="递延税项资产">
        <template slot-scope="scope">
          <div class="value-wrap">
            <span class="value">{{ $digitjs(scope.row[formatAParams('deferredTaxAssets')]).convert() }}</span>
            <span :style="{ color: $digitjs(scope.row[formatAParams('deferredTaxAssetsYoY')]).color() }" class="scale">
              {{ $digitjs(scope.row[formatAParams('deferredTaxAssetsYoY')]).prefix().unit('%').rounded() }}
            </span>
          </div>
        </template>
      </col-table-column>
      <col-table-column prop="statutoryDeposits" label="法定存款">
        <template slot-scope="scope">
          <div class="value-wrap">
            <span class="value">{{ $digitjs(scope.row[formatAParams('statutoryDeposits')]).convert() }}</span>
            <span :style="{ color: $digitjs(scope.row[formatAParams('statutoryDepositsYoY')]).color() }" class="scale">
              {{ $digitjs(scope.row[formatAParams('statutoryDepositsYoY')]).prefix().unit('%').rounded() }}
            </span>
          </div>
        </template>
      </col-table-column>
      <col-table-column prop="cashAndNearCash" label="现金及银行结存">
        <template slot-scope="scope">
          <div class="value-wrap">
            <span class="value">{{ $digitjs(scope.row[formatAParams('cashAndNearCash')]).convert() }}</span>
            <span :style="{ color: $digitjs(scope.row[formatAParams('cashAndNearCashYoY')]).color() }" class="scale">
              {{ $digitjs(scope.row[formatAParams('cashAndNearCashYoY')]).prefix().unit('%').rounded() }}
            </span>
          </div>
        </template>
      </col-table-column>
      <col-table-column prop="otherAssets" label="其他资产">
        <template slot-scope="scope">
          <div class="value-wrap">
            <span class="value">{{ $digitjs(scope.row[formatAParams('otherAssets')]).convert() }}</span>
            <span :style="{ color: $digitjs(scope.row[formatAParams('otherAssetsYoY')]).color() }" class="scale">
              {{ $digitjs(scope.row[formatAParams('otherAssetsYoY')]).prefix().unit('%').rounded() }}
            </span>
          </div>
        </template>
      </col-table-column>
      <col-table-column prop="totalAssets" label="总资产" :css="{ marginBottom: '17px' }">
        <template slot-scope="scope">
          <div class="value-wrap">
            <span class="value">{{ $digitjs(scope.row[formatAParams('totalAssets')]).convert() }}</span>
            <span :style="{ color: $digitjs(scope.row[formatAParams('totalAssetsYoY')]).color() }" class="scale">
              {{ $digitjs(scope.row[formatAParams('totalAssetsYoY')]).prefix().unit('%').rounded() }}
            </span>
          </div>
        </template>
      </col-table-column>
      <col-table-column :css="css">
        <template #header>负债</template>
      </col-table-column>
      <col-table-column prop="insuranceFunds" label="保险准备金">
        <template slot-scope="scope">
          <div class="value-wrap">
            <span class="value">{{ $digitjs(scope.row[formatAParams('insuranceFunds')]).convert() }}</span>
            <span :style="{ color: $digitjs(scope.row[formatAParams('insuranceFundsYoY')]).color() }" class="scale">
              {{ $digitjs(scope.row[formatAParams('insuranceFundsYoY')]).prefix().unit('%').rounded() }}
            </span>
          </div>
        </template>
      </col-table-column>
      <col-table-column prop="insuranceProtectionFund" label="保险保障基金">
        <template slot-scope="scope">
          <div class="value-wrap">
            <span class="value">{{ $digitjs(scope.row[formatAParams('insuranceProtectionFund')]).convert() }}</span>
            <span
              :style="{ color: $digitjs(scope.row[formatAParams('insuranceProtectionFundYoY')]).color() }"
              class="scale"
            >
              {{ $digitjs(scope.row[formatAParams('insuranceProtectionFundYoY')]).prefix().unit('%').rounded() }}
            </span>
          </div>
        </template>
      </col-table-column>
      <col-table-column prop="insurancePayables" label="应付保险款项">
        <template slot-scope="scope">
          <div class="value-wrap">
            <span class="value">{{ $digitjs(scope.row[formatAParams('insurancePayables')]).convert() }}</span>
            <span :style="{ color: $digitjs(scope.row[formatAParams('insurancePayablesYoY')]).color() }" class="scale">
              {{ $digitjs(scope.row[formatAParams('insurancePayablesYoY')]).prefix().unit('%').rounded() }}
            </span>
          </div>
        </template>
      </col-table-column>
      <col-table-column prop="investmentContractLiabilities" label="保户投资合同负债">
        <template slot-scope="scope">
          <div class="value-wrap">
            <span class="value">{{
              $digitjs(scope.row[formatAParams('investmentContractLiabilities')]).convert()
            }}</span>
            <span
              :style="{ color: $digitjs(scope.row[formatAParams('investmentContractLiabilitiesYoY')]).color() }"
              class="scale"
            >
              {{ $digitjs(scope.row[formatAParams('investmentContractLiabilitiesYoY')]).prefix().unit('%').rounded() }}
            </span>
          </div>
        </template>
      </col-table-column>
      <col-table-column prop="assetsSoldRepurchase" label="卖出回购资产">
        <template slot-scope="scope">
          <div class="value-wrap">
            <span class="value">{{ $digitjs(scope.row[formatAParams('assetsSoldRepurchase')]).convert() }}</span>
            <span
              :style="{ color: $digitjs(scope.row[formatAParams('assetsSoldRepurchaseYoY')]).color() }"
              class="scale"
            >
              {{ $digitjs(scope.row[formatAParams('assetsSoldRepurchaseYoY')]).prefix().unit('%').rounded() }}
            </span>
          </div>
        </template>
      </col-table-column>
      <col-table-column prop="derivativeFinancialLiabilities" label="衍生金融负债">
        <template slot-scope="scope">
          <div class="value-wrap">
            <span class="value">{{
              $digitjs(scope.row[formatAParams('derivativeFinancialLiabilities')]).convert()
            }}</span>
            <span
              :style="{ color: $digitjs(scope.row[formatAParams('derivativeFinancialLiabilitiesYoY')]).color() }"
              class="scale"
            >
              {{ $digitjs(scope.row[formatAParams('derivativeFinancialLiabilitiesYoY')]).prefix().unit('%').rounded() }}
            </span>
          </div>
        </template>
      </col-table-column>
      <col-table-column prop="amountsDueRelatedParties" label="应付关连公司款项">
        <template slot-scope="scope">
          <div class="value-wrap">
            <span class="value">{{ $digitjs(scope.row[formatAParams('amountsDueRelatedParties')]).convert() }}</span>
            <span
              :style="{ color: $digitjs(scope.row[formatAParams('amountsDueRelatedPartiesYoY')]).color() }"
              class="scale"
            >
              {{ $digitjs(scope.row[formatAParams('amountsDueRelatedPartiesYoY')]).prefix().unit('%').rounded() }}
            </span>
          </div>
        </template>
      </col-table-column>
      <col-table-column prop="currentTaxation" label="应付所得税">
        <template slot-scope="scope">
          <div class="value-wrap">
            <span class="value">{{ $digitjs(scope.row[formatAParams('currentTaxation')]).convert() }}</span>
            <span :style="{ color: $digitjs(scope.row[formatAParams('currentTaxationYoY')]).color() }" class="scale">
              {{ $digitjs(scope.row[formatAParams('currentTaxationYoY')]).prefix().unit('%').rounded() }}
            </span>
          </div>
        </template>
      </col-table-column>
      <col-table-column prop="deferredTaxLiabilities" label="递延税项负债">
        <template slot-scope="scope">
          <div class="value-wrap">
            <span class="value">{{ $digitjs(scope.row[formatAParams('deferredTaxLiabilities')]).convert() }}</span>
            <span
              :style="{ color: $digitjs(scope.row[formatAParams('deferredTaxLiabilitiesYoY')]).color() }"
              class="scale"
            >
              {{ $digitjs(scope.row[formatAParams('deferredTaxLiabilitiesYoY')]).prefix().unit('%').rounded() }}
            </span>
          </div>
        </template>
      </col-table-column>
      <col-table-column prop="otherLiabilities" label="其他负债">
        <template slot-scope="scope">
          <div class="value-wrap">
            <span class="value">{{ $digitjs(scope.row[formatAParams('otherLiabilities')]).convert() }}</span>
            <span :style="{ color: $digitjs(scope.row[formatAParams('otherLiabilitiesYoY')]).color() }" class="scale">
              {{ $digitjs(scope.row[formatAParams('otherLiabilitiesYoY')]).prefix().unit('%').rounded() }}
            </span>
          </div>
        </template>
      </col-table-column>
      <col-table-column prop="totalLiabilities" label="总负债" :css="{ marginBottom: '17px' }">
        <template slot-scope="scope">
          <div class="value-wrap">
            <span class="value">{{ $digitjs(scope.row[formatAParams('totalLiabilities')]).convert() }}</span>
            <span :style="{ color: $digitjs(scope.row[formatAParams('totalLiabilitiesYoY')]).color() }" class="scale">
              {{ $digitjs(scope.row[formatAParams('totalLiabilitiesYoY')]).prefix().unit('%').rounded() }}
            </span>
          </div>
        </template>
      </col-table-column>
      <col-table-column :css="css">
        <template #header>股东权益</template>
      </col-table-column>
      <col-table-column prop="capitalReserve" label="资本储备">
        <template slot-scope="scope">
          <div class="value-wrap">
            <span class="value">{{ $digitjs(scope.row[formatAParams('capitalReserve')]).convert() }}</span>
            <span :style="{ color: $digitjs(scope.row[formatAParams('capitalReserveYoY')]).color() }" class="scale">
              {{ $digitjs(scope.row[formatAParams('capitalReserveYoY')]).prefix().unit('%').rounded() }}
            </span>
          </div>
        </template>
      </col-table-column>
      <col-table-column prop="otherReserves" label="其他储备">
        <template slot-scope="scope">
          <div class="value-wrap">
            <span class="value">{{ $digitjs(scope.row[formatAParams('otherReserves')]).convert() }}</span>
            <span :style="{ color: $digitjs(scope.row[formatAParams('otherReservesYoY')]).color() }" class="scale">
              {{ $digitjs(scope.row[formatAParams('otherReservesYoY')]).prefix().unit('%').rounded() }}
            </span>
          </div>
        </template>
      </col-table-column>
      <col-table-column prop="totalReserves" label="储备总额">
        <template slot-scope="scope">
          <div class="value-wrap">
            <span class="value">{{ $digitjs(scope.row[formatAParams('totalReserves')]).convert() }}</span>
            <span :style="{ color: $digitjs(scope.row[formatAParams('totalReservesYoY')]).color() }" class="scale">
              {{ $digitjs(scope.row[formatAParams('totalReservesYoY')]).prefix().unit('%').rounded() }}
            </span>
          </div>
        </template>
      </col-table-column>
      <col-table-column prop="ownersEquity" label="本公司拥有人应占权益">
        <template slot-scope="scope">
          <div class="value-wrap">
            <span class="value">{{ $digitjs(scope.row[formatAParams('ownersEquity')]).convert() }}</span>
            <span :style="{ color: $digitjs(scope.row[formatAParams('ownersEquityYoY')]).color() }" class="scale">
              {{ $digitjs(scope.row[formatAParams('ownersEquityYoY')]).prefix().unit('%').rounded() }}
            </span>
          </div>
        </template>
      </col-table-column>
      <col-table-column prop="policyholdersEquity" label="保单持有人权益">
        <template slot-scope="scope">
          <div class="value-wrap">
            <span class="value">{{ $digitjs(scope.row[formatAParams('policyholdersEquity')]).convert() }}</span>
            <span
              :style="{ color: $digitjs(scope.row[formatAParams('policyholdersEquityYoY')]).color() }"
              class="scale"
            >
              {{ $digitjs(scope.row[formatAParams('policyholdersEquityYoY')]).prefix().unit('%').rounded() }}
            </span>
          </div>
        </template>
      </col-table-column>
      <col-table-column prop="nonControllingInterests" label="非控股权益">
        <template slot-scope="scope">
          <div class="value-wrap">
            <span class="value">{{ $digitjs(scope.row[formatAParams('nonControllingInterests')]).convert() }}</span>
            <span
              :style="{ color: $digitjs(scope.row[formatAParams('nonControllingInterestsYoY')]).color() }"
              class="scale"
            >
              {{ $digitjs(scope.row[formatAParams('nonControllingInterestsYoY')]).prefix().unit('%').rounded() }}
            </span>
          </div>
        </template>
      </col-table-column>
      <col-table-column prop="totalEquity" label="权益总额">
        <template slot-scope="scope">
          <div class="value-wrap">
            <span class="value">{{ $digitjs(scope.row[formatAParams('totalEquity')]).convert() }}</span>
            <span :style="{ color: $digitjs(scope.row[formatAParams('totalEquityYoY')]).color() }" class="scale">
              {{ $digitjs(scope.row[formatAParams('totalEquityYoY')]).prefix().unit('%').rounded() }}
            </span>
          </div>
        </template>
      </col-table-column>
    </col-table>
    <RkPopup :visible.sync="popupVisible"><ReportSheetPrompt /></RkPopup>
  </div>
</template>

<script>
import RkPopup from '@/components/common/Popup.vue'
import ReportSheetPrompt from '@/components/common/ReportSheetPrompt.vue'
export default {
  components: { RkPopup, ReportSheetPrompt },
  props: ['data', 'reportKindMap', 'css', 'mainDataStyle', 'formatAParams'],
  data() {
    return {
      isSame: false,
      popupVisible: false
    }
  },
  computed: {
    pageSize() {
      return this.isSame ? 1 : 2
    }
  }
}
</script>
